import { ApiConfigurationParams } from '@tourfold/tf-api-client-public-v1/api-configuration';
import { ApiConfigurationParams as ApiConfigurationParamsV2 } from '@tourfold/tf-api-client-public-v2/api-configuration';
import { ApiConfigurationParams as AdminApiConfigurationParams } from '@tourfold/tf-api-client-admin-v1/api-configuration';

export class ApiUrlProvider implements ApiConfigurationParams, ApiConfigurationParamsV2 {
  public useApiReviewUrl: boolean | undefined;

  public get rootUrl(): string {
    if (this.useApiReviewUrl) {
      return 'https://api.app-review.int.tourfold.com';
    } else {
      try {
        const apiBaseUrl = (window as any).spaConfig.endpoints.api;
        return apiBaseUrl;
      } catch (error) {
        console.error('SpaConfig error', error);
        return 'https://dispo-xyz-api.prod.dispo.xyz';
      }
    }
  }
}

export class AdminApiUrlProvider implements AdminApiConfigurationParams {
  public get rootUrl(): string {
    try {
      const adminApiBaseUrl = (window as any).spaConfig.endpoints['admin-api'];
      return adminApiBaseUrl;
    } catch (error) {
      console.error('SpaConfig error', error);
      return 'http://localhost:5002'; // Default to local dev admin-api
    }
  }
}

export class AuthIssuerUrlProvider {
  public get issuer(): string {
    try {
      const authIssuer = (window as any).spaConfig.endpoints['auth-issuer'];
      return authIssuer;
    } catch (error) {
      console.error('SpaConfig error', error);
      return 'http://localhost:5099/realms/tourfold-admin'; // Default to local dev
    }
  }
}

export abstract class SpaConfig {
  public static apiUrlProvider: ApiUrlProvider = new ApiUrlProvider();
  public static adminApiUrlProvider: AdminApiUrlProvider = new AdminApiUrlProvider();
  public static authIssuerUrlProvider: AuthIssuerUrlProvider = new AuthIssuerUrlProvider();
}
